var _excluded = ["icon", "name"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { fal } from '@fortawesome/pro-light-svg-icons';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import { fat } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon as KendoIcon } from '@progress/kendo-react-common';
library.add(fab, fad, fal, far, fas, fat);

/**
 * The Icon component is used to display font icons.
 * All Kendo UI and Font Awesome Pro icons are supported.
 */
var Icon = props => {
  var {
      icon,
      name
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  if (name) {
    return /*#__PURE__*/React.createElement(KendoIcon, _extends({
      name: name
    }, rest));
  }
  if (icon) {
    return /*#__PURE__*/React.createElement(FontAwesomeIcon, _extends({
      icon: icon
    }, rest));
  }
  return null;
};
Icon.defaultProps = {
  icon: undefined,
  name: undefined
};
Icon.propTypes = {
  /**
   * Used to display FontAwesome icons
   */
  icon: PropTypes.arrayOf(PropTypes.string),
  /**
   * Used to display Kendo icons
   */
  name: PropTypes.string
};
export default Icon;